import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="inicio" className="relative flex min-h-[760px] h-screen items-center justify-center overflow-hidden bg-[#1A1A1A] px-5 text-white md:px-10" data-id="element-119" data-mp="ejwl1drxcj8d">
      <motion.video initial={{
      scale: 1.08
    }} animate={{
      scale: 1
    }} transition={{
      duration: 11,
      ease: 'easeOut'
    }} src="https://cdn.magicpatterns.com/uploads/gCLzxytgnGCcCPW5grGnNr/video-e31c3365-f5ed-40c0-9977-1348b1aa54f6%20%281%29.mp4" autoPlay loop muted playsInline className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-120" data-mp="9ipaj6yed5y0" />
      <div className="absolute inset-0 bg-black/40" data-id="element-121" data-mp="nbosdflnjc8q" />
      <motion.div initial={{
      opacity: 0,
      y: 34
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.25,
      duration: 0.8
    }} className="relative mx-auto flex w-full max-w-5xl flex-col items-center text-center" data-id="element-122" data-mp="3d21sdxnwkknq">
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[.22em] text-[#e9c8b6]" data-id="element-123" data-mp="3o73o289n1o6h">
          Estudio de arquitectura · Montevideo
        </p>
        <h1 className="font-editorial text-5xl leading-[1.02] tracking-tight sm:text-6xl md:text-8xl" data-id="element-124" data-mp="3e963pvuwgbj5">
          Espacios que inspiran.
          <br data-id="element-125" data-mp="30h9djxcskbpe" />
          Arquitectura que permanece.
        </h1>
        <p className="mt-7 max-w-md text-sm leading-6 text-white/85 md:text-base" data-id="element-126" data-mp="3599jq7jgg0uf">
          Diseño arquitectónico residencial y comercial con identidad propia.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-3" data-id="element-127" data-mp="2qi0o9hsvfl9d">
          <a href="#proyectos" className="bg-[#C4724A] px-6 py-3.5 text-xs font-bold uppercase tracking-wider transition-colors hover:bg-[#a95d3b]" data-id="element-128" data-mp="2vjg48vg6z1kw">
            Ver proyectos
          </a>
          <a href="#contacto" className="border border-white px-6 py-3.5 text-xs font-bold uppercase tracking-wider transition-colors hover:bg-white hover:text-[#1A1A1A]" data-id="element-129" data-mp="2lmlaepuv5pcy">
            Agendar consulta
          </a>
        </div>
      </motion.div>
    </section>;
}